"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Flex = _interopRequireDefault(require("./Flex"));
var _Paragraph = _interopRequireDefault(require("./Paragraph"));
var _BadgeImageLeft = _interopRequireDefault(require("./assets/BadgeImage-Left.svg"));
var _BadgeImageRight = _interopRequireDefault(require("./assets/BadgeImage-Right.svg"));
require("./BadgeLevel.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// import BadgeImage from "./../assets/BadgeImageMini.svg";

var BadgeLevel = function BadgeLevel(_ref) {
  var badge = _ref.badge;
  var badgeNumber = badge || 1; // Default badge number to 1 if not provided

  return /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    customClass: "BadgeLevel"
  }, /*#__PURE__*/_react["default"].createElement(_Paragraph["default"], {
    size: "large",
    weight: "bold"
  }, badgeNumber), /*#__PURE__*/_react["default"].createElement("img", {
    className: "BadgeImageLeft",
    src: _BadgeImageLeft["default"],
    alt: "Badge level"
  }), /*#__PURE__*/_react["default"].createElement("img", {
    className: "BadgeImageRight",
    src: _BadgeImageRight["default"],
    alt: "Badge level"
  }));
};
var _default = exports["default"] = BadgeLevel;